"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChatwootIdentity = void 0;
const fetchInstance_1 = require("../../../utils/fetchInstance");
/**
* @summary Get the current shop's Chatwoot identity-validation payload
*/
const getChatwootIdentity = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/chatwoot/identity`, method: 'get'
    });
};
exports.getChatwootIdentity = getChatwootIdentity;
